import { Box, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import appConfig from "../../../config/config";
import { getSupportChannelConfig } from "../../../utils/getSupportChannelConfig";

/**
 * The strip under every page, as in the click dummy: who secures the payment on
 * the left, how to reach support on the right.
 *
 * The support side renders only what this deployment configured. The dummy's
 * number is demo data; a portal with no WhatsApp or Zoho configured shows the
 * secured line alone rather than a control that goes nowhere.
 */
const PortalFooter = () => {
  const { t } = useTranslation();
  const { zohoUrl, whatsappNumber } = getSupportChannelConfig(appConfig);
  const digits = (whatsappNumber ?? "").replace(/\D/g, "");

  const support = digits
    ? { href: `https://wa.me/${digits}`, label: `+${digits}` }
    : zohoUrl
    ? { href: zohoUrl, label: "" }
    : null;

  return (
    <Box
      component="footer"
      sx={{ borderTop: 1, borderColor: "divider", bgcolor: "background.paper" }}
    >
      <Box
        sx={{
          maxWidth: 1040,
          mx: "auto",
          px: { xs: 2, sm: 3 },
          py: 1.75,
          display: "flex",
          justifyContent: "space-between",
          gap: "8px 20px",
          flexWrap: "wrap",
          fontSize: 13,
          color: "text.secondary",
        }}
      >
        <Box component="span">
          <Box component="b" sx={{ color: "text.primary", fontWeight: 600 }}>
            {t("footer.secured")}
          </Box>{" "}
          · {t("footer.powered")}
        </Box>
        {support && (
          <Link
            href={support.href}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ color: "text.secondary" }}
          >
            {support.label
              ? `${t("footer.support")}: ${support.label}`
              : t("footer.support")}
          </Link>
        )}
      </Box>
    </Box>
  );
};

export default PortalFooter;
